import {
  GET_SALESPROMO,
  GET_SALESPROMO_SUCCESS,
  GET_SALESPROMO_FAIL,
  DELETE_SALESPROMO,
  DELETE_SALESPROMO_SUCCESS,
  DELETE_SALESPROMO_FAIL,
  UPDATE_SALESPROMO,
  UPDATE_SALESPROMO_SUCCESS,
  UPDATE_SALESPROMO_FAIL,
  ADD_NEW_SALESPROMO,
  ADD_SALESPROMO_SUCCESS,
  ADD_SALESPROMO_FAIL,
  SALESPROMO_LOADING,
  SALESPROMO_RESET,
} from "./actionType";

export const resetSalesPromoState = (actionType) => ({
  type: SALESPROMO_RESET,
  payload: { actionType },
});

export const getSalesPromoSuccess = (actionType, data) => ({
  type: GET_SALESPROMO_SUCCESS,
  payload: { actionType, data },
});

export const getSalesPromoFail = (actionType, error) => ({
  type: GET_SALESPROMO_FAIL,
  payload: { actionType, error },
});

export const getSalesPromo = data => ({
  type: GET_SALESPROMO,
  payload: data,
});

export const getSalesPromoLoading = () => ({
  type: SALESPROMO_LOADING
});

export const deleteSalesPromo = data => ({
  type: DELETE_SALESPROMO,
  payload: data,
});

export const deleteSalesPromoSuccess = data => ({
  type: DELETE_SALESPROMO_SUCCESS,
  payload: data,
});

export const deleteSalesPromoFail = error => ({
  type: DELETE_SALESPROMO_FAIL,
  payload: error,
});

export const updateSalesPromo = data => ({
  type: UPDATE_SALESPROMO,
  payload: data,
});

export const updateSalesPromoFail = error => ({
  type: UPDATE_SALESPROMO_FAIL,
  payload: error,
});

export const updateSalesPromoSuccess = data => ({
  type: UPDATE_SALESPROMO_SUCCESS,
  payload: data,
});

export const addNewSalesPromo = data => ({
  type: ADD_NEW_SALESPROMO,
  payload: data,
});

export const addSalesPromoSuccess = data => ({
  type: ADD_SALESPROMO_SUCCESS,
  payload: data,
});

export const addSalesPromoFail = error => ({
  type: ADD_SALESPROMO_FAIL,
  payload: error,
});